export const filterIn = (key: string, values: string[], not = false) =>
  `${key}:${not ? "!" : ""}=['${values.join("','")}']`;

export const filterNotIn = (key: string, values: string[]) =>
  filterIn(key, values, true);

export const join = (filters: string[]) => filters.join(" && ");
